import { render, staticRenderFns } from "./TariffCalculatorProduct.vue?vue&type=template&id=337c4ceb&"
import script from "./TariffCalculatorProduct.vue?vue&type=script&lang=ts&"
export * from "./TariffCalculatorProduct.vue?vue&type=script&lang=ts&"
import style0 from "./TariffCalculatorProduct.vue?vue&type=style&index=0&lang=postcss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports